export { default } from './NumberPlate';
